module.exports = __webpack_public_path__ + "img/c509309.png";